import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=f143c664&scoped=true"
import script from "./DateField.vue?vue&type=script&lang=ts"
export * from "./DateField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f143c664",
  null
  
)

export default component.exports